import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, BACKGROUND_BTN_BACK, BACKGROUND_BTN_BACK_HOVER, FONT_SIZE_BTN_BACK, FONT_SIZE_BTN_BACK_ARROW } from '../../../globals';


export const StyledBtnBack = styled.div`
  padding: 15px ${PADDING_CONTENT_PAGE}px 15px ${PADDING_CONTENT_PAGE}px;
  font-size: ${FONT_SIZE_BTN_BACK}}px;
  font-weight: bold;
  color: ${BACKGROUND_BTN_BACK};
  text-transform: uppercase;

  
  .btn-back-content {
    color: inherit;
    text-decoration: none;
    display:table;
   }

  .btn-back-content:hover {
    color: ${BACKGROUND_BTN_BACK_HOVER};
    text-decoration: none;
   }

  .btn-back-content:visited, .btn-back-content:active {
    text-decoration: none;
  }

  .btn-back-text {
    padding-left: 15px;
    display:table-cell;
    vertical-align: middle;
    text-decoration: underline;
  }

  .btn-back-arrow {
    font-size: ${FONT_SIZE_BTN_BACK_ARROW}px;
    display:table-cell;
    vertical-align: middle;
  }
`;
